var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "mapboxgl-ctrl mapboxgl-ctrl-group bg-blue-dk",
      attrs: { id: "mapCenter" }
    },
    [
      _vm.loading
        ? _c(
            "div",
            { staticClass: "mapboxgl-ctrl-icon text-light px-2 loading-ctrl" },
            [_vm._m(0)]
          )
        : _c(
            "button",
            {
              staticClass: "mapboxgl-ctrl-icon",
              attrs: { title: "center map on current location" },
              on: { click: _vm.center }
            },
            [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v("my_location")
              ])
            ]
          )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "loading-dots justify-content-center align-self-center" },
      [
        _c("div", { staticClass: "dot" }),
        _vm._v(" "),
        _c("div", { staticClass: "dot" }),
        _vm._v(" "),
        _c("div", { staticClass: "dot" })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6ddf0bee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ddf0bee","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/map-center.vue
// module id = null
// module chunks = 